export const DEFAULT_ERR_MSG =
  "Ein Fehler ist aufgetreten bitte lade die Seite neu";
export const formatSnackBarErrMsg = (status: number, errMsg: string) => {
  return `${status} | ${errMsg}`;
};
